<!-- 
Dialog for running a scheduled job.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog xs">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Run scheduled job</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="state.processing"/>
      <v-card-text>
        Are you sure you want to run the 
        "<strong>{{ description }}</strong>"
        scheduled job?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.processing" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.processing" flat color="success" @click="runScheduledJob">
          Run
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as action from "@/store/scheduled-jobs/action-types";
import * as mutation from "@/store/scheduled-jobs/mutation-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    scheduledJobId: {
      type: Number,
      default: null
    },
    description: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      scheduledJob: {}
    };
  },
  computed: {
    state() {
      return this.$store.state.scheduledJobs.run;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        this.$store.commit(mutation.RUN_INITIALISE);
      }
    }
  },
  methods: {
    async runScheduledJob() {
      await this.$store.dispatch(action.RUN, this.scheduledJobId);
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
